
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('defs',[_c('style',[_v('.a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}')])]),_c('title',[_v('cursor-double-click-3')]),_c('path',{staticClass:"a",attrs:{"d":"M10.536,11.568l2.68,8.931a.83.83,0,0,0,1.382.349l1.365-1.365,3.522,3.522a.83.83,0,0,0,1.174,0l2.348-2.348a.83.83,0,0,0,0-1.174l-3.522-3.522L20.85,14.6a.83.83,0,0,0-.348-1.382l-8.932-2.68A.831.831,0,0,0,10.536,11.568Z"}}),_c('path',{staticClass:"a",attrs:{"d":"M21.723,10.5A10.5,10.5,0,1,0,10.5,21.721"}}),_c('path',{staticClass:"a",attrs:{"d":"M16.813,9A6,6,0,1,0,9,16.811"}})])])
          )
        }
      }
    